/**
 * Kingsland international routing.
 *
 * Reads window.KingslandRouting (emitted by snippets/international-routing.liquid,
 * which resolves the visitor's market server-side via localization.country.iso_code).
 *
 * The "family" is the primary listing plus every market-specific listing.
 * For the visitor's market, the "desired" listing is markets[country] if mapped,
 * otherwise the primary.
 *
 *  1. Direct hit: if the visitor is on any family listing that isn't the desired
 *     one for their market, redirect once to the desired one.
 *  2. Link rewrite: every on-page link to any family listing is pointed at the
 *     desired one (nav, homepage, footer, drawers, AJAX-rendered content).
 *  3. Country selector: when a country is chosen while on a family listing, the
 *     localization form's return_to is set to that country's listing, so Shopify
 *     lands there instead of bouncing to the homepage (which is what it does when
 *     the current page is hidden in the newly selected market).
 *
 *  4. Market-restricted products: links to any handle in hiddenHandles (computed
 *     server-side from the country allow-list setting) are hidden.
 *
 * Handle matching is exact on the /products/<handle> path segment — several
 * localized handles share the primary handle as a prefix, so prefix matching
 * would loop.
 */
(function () {
  var config = window.KingslandRouting;
  if (!config || !config.enabled) return;

  var markets = config.markets || {};
  var country = config.currentCountry || '';
  var primary = config.primaryHandle || '';
  var hiddenHandles = config.hiddenHandles || [];
  var routingActive = !!primary;

  var family = {};
  family[primary] = true;
  Object.keys(markets).forEach(function (code) {
    if (markets[code]) family[markets[code]] = true;
  });

  function desiredFor(code) {
    return (code && markets[code]) || primary;
  }

  // Matches "/products/<handle>" as a whole path segment, anywhere in the path
  // (covers /collections/x/products/<handle> too). Returns the handle or null.
  var productSegment = /(^|\/)products\/([^\/?#]+)(?=$|[\/?#])/;

  function familyHandleIn(pathname) {
    var m = productSegment.exec(pathname);
    if (!m) return null;
    var handle = m[2].toLowerCase();
    return family[handle] ? handle : null;
  }

  function replaceHandle(pathname, newHandle) {
    return pathname.replace(productSegment, function (_, lead) {
      return lead + 'products/' + newHandle;
    });
  }

  var desired = desiredFor(country);

  // 1. Direct hit.
  var currentHandle = routingActive ? familyHandleIn(window.location.pathname) : null;
  if (currentHandle && currentHandle !== desired) {
    window.location.replace(
      replaceHandle(window.location.pathname, desired) + window.location.search + window.location.hash
    );
    return;
  }

  // 4. Market-restricted products: hide links to products not published in
  //    this market. Hides the enclosing <li> when the link is its only content
  //    (menus), otherwise just the link.
  var hiddenSet = {};
  hiddenHandles.forEach(function (h) { if (h) hiddenSet[String(h).toLowerCase()] = true; });

  function hideLink(link) {
    var li = link.closest('li');
    var target = link;
    // Menu items: the <li> holds only this one link (plus icons/markup) — hide the whole item.
    if (li && li.querySelectorAll('a').length === 1) target = li;
    target.hidden = true;
    target.style.display = 'none';
    target.setAttribute('data-kingsland-hidden', '');
  }

  // 2. Link rewrite (+ hiding, same pass).
  function swapLinks() {
    var links = document.querySelectorAll('a[href*="/products/"]');
    for (var i = 0; i < links.length; i++) {
      var link = links[i];
      var url;
      try {
        url = new URL(link.getAttribute('href'), window.location.origin);
      } catch (e) {
        continue;
      }
      if (url.origin !== window.location.origin) continue;

      var seg = productSegment.exec(url.pathname);
      var linkHandle = seg ? seg[2].toLowerCase() : null;
      if (linkHandle && hiddenSet[linkHandle]) {
        hideLink(link);
        continue;
      }

      if (!routingActive) continue;
      var handle = familyHandleIn(url.pathname);
      if (handle && handle !== desired) {
        link.setAttribute('href', replaceHandle(url.pathname, desired) + url.search + url.hash);
      }
    }
  }

  // 3. Country selector: steer return_to to the chosen country's listing.
  function patchLocalizationForms() {
    var forms = document.querySelectorAll('form[action*="/localization"]');
    for (var i = 0; i < forms.length; i++) {
      var form = forms[i];
      if (form.__kingslandPatched) continue;
      form.__kingslandPatched = true;
      form.submit = function () {
        try {
          var countryField = this.querySelector('[name="country_code"]');
          var returnTo = this.querySelector('input[name="return_to"]');
          if (countryField && returnTo) {
            var basePath = returnTo.value || window.location.pathname;
            var onHandle = familyHandleIn(basePath);
            if (onHandle) {
              returnTo.value = replaceHandle(basePath, desiredFor(countryField.value));
            }
          }
        } catch (e) {}
        HTMLFormElement.prototype.submit.call(this);
      };
    }
  }

  function run() {
    swapLinks();
    if (routingActive) patchLocalizationForms();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  // Cover content rendered after load (menus, drawers, AJAX cart, predictive search).
  var scheduled = false;
  var observer = new MutationObserver(function (mutations) {
    if (scheduled) return;
    for (var i = 0; i < mutations.length; i++) {
      if (mutations[i].addedNodes && mutations[i].addedNodes.length) {
        scheduled = true;
        requestAnimationFrame(function () {
          scheduled = false;
          run();
        });
        break;
      }
    }
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
